/*
 * Purpose is to properly format a form prior to being submitted to the server.
 * Looks for form fields that contain objects where one property is 'value'
 * If a 'value' is found, it will replace the object in form[f] with just the value.
 * If no value is found, or if form[f].value is '', it will replace form[f] with ''.
 */
export default (form) => {
  for (let f in form) {
    if (!form.hasOwnProperty(f)) {
      continue
    }
    if (form[f].value && form[f].value !== '') {
      form[f] = form[f].value
    } else if (form[f].value === '') {
      form[f] = ''
    }
  }
  return form
}



// WEBPACK FOOTER //
// ./src/utils/helpers/SetValuesForPkFields.js